

<div class="text-center">
  <div fxLayout="row" fxLayoutWrap="wrap">
    <div fxFlex="40px">
      @if (status <= 3) {
        <i class="far fa-hourglass"></i>
      }
      @if (status === 5) {
        <i class="fas fa-exclamation-circle" style="color: red;"></i>
      }
      @if (status === 4) {
        <i class="far fa-check-circle" style="color: green;"></i>
      }
    </div>
    <div fxFlex style="margin-left: -40px;">
      {{ title }}
    </div>
  </div>
  <br/>
  @if (status <= 3) {
    <div mat-dialog-content>
      <mat-progress-bar [mode]="progressMode" [value]="progress"></mat-progress-bar>
    </div>
    <span style="padding-top: 20px; font-size: 9px;">{{'MODELS.SERVICES.APP-LONG-RUNNING-OPERATION.DONT-REFRESH-BROWSER' | translate}}</span>
  } @else {
    <button class="btn btn-default" (click)="dialogRef.close(false);">
      <i class="fas fa-ban"></i>
      <span>{{'MODELS.SERVICES.APP-LONG-RUNNING-OPERATION.CLOSE' | translate}}</span>
    </button>
  }

</div>


